module.exports = __webpack_public_path__ + "img/qr3.f021a043.png";